import { createApp, createSSRApp } from 'vue'
import { createWebHistory } from 'vue-router'
import App from './App.vue'
import { createAppRouter } from './router'
import './styles/tokens.css'

const root = document.getElementById('app')
const router = createAppRouter(createWebHistory())

// Every public route is prerendered into its own HTML file, tagged with the
// path it was rendered for. Hydrate only when that matches the URL we are on.
// Any other URL is served the shell via the host's catch-all rewrite (unknown
// pages, retired links); it must render from scratch rather than hydrate
// markup that belongs to a different page.
const normalise = (path) => (path.length > 1 ? path.replace(/\/+$/, '') : path)
const prerendered = root.getAttribute('data-prerendered')
root.removeAttribute('data-prerendered')
const hydrate = prerendered !== null && prerendered === normalise(window.location.pathname)

if (!hydrate) {
  root.innerHTML = ''
}

const app = (hydrate ? createSSRApp : createApp)(App).use(router)
router.isReady().then(() => app.mount(root))
